// 点评 list, 教师分享, 模板管理, trash button, and stored data values shown via tr(value)
const en = {
  // review-list
  "AI 设计分数：{aiDesignScoreText(s)}": "AI design score: {aiDesignScoreText(s)}",
  "评分标准：": "Rubric: ",
  " · 打分于 {new Date(s.scoredAt).toLocaleString(LOCALE)}": " · scored {new Date(s.scoredAt).toLocaleString(LOCALE)}",
  "维度": "Dimension",
  "得分": "Score",
  "评分理由": "Rationale",
  "考察要点": "What it assesses",
  "总评：{s.summary}": "Summary: {s.summary}",
  "分课时设计·课时{lessonIdx}": "Lesson design · Lesson {lessonIdx}",
  "实施记录·课时{lessonIdx}": "Implementation record · Lesson {lessonIdx}",
  "实施整体": "Overall implementation",
  "可选": "Optional",
  "有未保存的修改": "Unsaved changes",
  "已保存": "Saved",
  "请填写点评内容。": "Please write a review.",
  "点评已保存（尚未提交，仅自己可见）。": "Review saved (not submitted yet, visible only to you).",
  "保存点评失败。": "Failed to save the review.",
  "提交点评失败。": "Failed to submit the review.",
  "已恢复登录超时前未保存的点评，请检查后保存或提交。": "Restored an unsaved review from before your session timed out. Please check it, then save or submit.",
  "加载点评列表失败。": "Failed to load reviews.",
  "当前课程内容已有按现行标准生成的 AI 点评（见下方列表），无需重复生成；修改课程内容后可再次请求。":
    "The current course content already has an AI review under the active rubric (see the list below). You can request another after changing the course content.",
  "AI 点评已生成{0}。": "AI review generated{0}.",
  "AI 点评生成失败。": "AI review generation failed.",
  "整体": "Overall",
  "确定要删除该已保存的点评吗？": "Delete this saved review?",
  "确定要删除该点评吗？": "Delete this review?",
  "点评（{0}）": "Reviews ({0})",
  "点评（实施整体）": "Reviews (overall implementation)",
  "点评（整体）": "Reviews (overall)",
  "AI点评生成中...": "Generating AI review...",
  "请AI点评": "Ask AI to review",
  "评分（可选）": "Score (optional)",
  "请针对 {0} 部分填写点评...": "Write your review of {0}...",
  "请填写点评内容...": "Write your review...",
  "保存点评": "Save review",
  "提交点评": "Submit review",
  "请填写留言...": "Write a comment...",
  "AI点评生成中…": "Generating AI review…",
  "暂无点评": "No reviews yet",
  "模块": "Section",
  "评分": "Score",
  "内容": "Content",
  "点评人": "Reviewer",
  "时间": "Time",
  "课程内容已在此点评后被修改": "The course content changed after this review",
  "内容已更新": "Content updated",
  "模型：{review.aiModel}": "Model: {review.aiModel}",
  "依据 AI 点评标准 #{review.standardId}": "Based on AI review rubric #{review.standardId}",
  "AI点评": "AI review",
  "管理员点评": "Admin review",
  "仅自己可见，提交后教师与其他人才能看到": "Only you can see this; the teacher and others see it once submitted",
  "已保存·未提交": "Saved · not submitted",
  "新": "New",
  "AI智能体": "AI agent",
  "返回点评内容": "Back to the reviewed content",
  "查看各维度得分与评分标准": "See dimension scores and the rubric",
  "打开欣欣小助手，就这条点评继续提问": "Open Xinxin Assistant to ask follow-up questions about this review",
  "讨论": "Discuss",
  "收起": "Collapse",
  "展开全文": "Show full text",
  "见下方": "see below",
  "展开": "Expand",

  // teacher-share
  "该话题下已有分享，不能修改或删除": "This topic already has shares and can't be edited or deleted",
  "上传分享": "Upload share",
  "我要分享": "Share",
  "加载分享话题失败。": "Failed to load share topics.",
  "加载教师分享失败。": "Failed to load teacher shares.",
  "该分享不存在或已被删除。": "This share doesn't exist or was deleted.",
  "加载分享失败。": "Failed to load the share.",
  "请填写话题名称。": "Please enter a topic name.",
  "创建话题失败。": "Failed to create the topic.",
  "修改话题失败。": "Failed to update the topic.",
  "确定删除话题「{topic.title}」吗？": "Delete topic \"{topic.title}\"?",
  "话题已删除。": "Topic deleted.",
  "删除话题失败。": "Failed to delete the topic.",
  "请填写分享标题。": "Please enter a title.",
  "请选择分享的作者教师。": "Please choose the authoring teacher.",
  "分享已发布，可在下方「分享内容」中上传 Word 文档、课件等文件。": "Share published. You can upload Word documents, slides and other files under \"Share content\" below.",
  "发布分享失败。": "Failed to publish the share.",
  "保存分享失败。": "Failed to save the share.",
  "此操作将永久删除该分享及其所有文件，且无法撤销。确定继续吗？": "This will permanently delete the share and all its files, and cannot be undone. Continue?",
  "分享已删除。": "Share deleted.",
  "删除分享失败。": "Failed to delete the share.",
  "作者教师": "Author",
  "输入教师姓名搜索...": "Search by teacher name...",
  "没有找到教师": "No teachers found",
  "如：《黄陂三鲜》让孩子重新认识了家乡": "e.g. How a lesson on local food helped kids rediscover their hometown",
  "简介": "Summary",
  "简要说明您的观点或经验（可选）": "Briefly describe your view or experience (optional)",
  "关联课程（可选）": "Related course (optional)",
  "选择作者教师的一门乡土课程...": "Choose one of the author's courses...",
  "选择您的一门乡土课程...": "Choose one of your courses...",
  "没有找到课程": "No courses found",
  "话题名称，如：一堂乡土课程带来的影响": "Topic name, e.g. The impact of one local-culture lesson",
  "话题说明（可选）": "Topic description (optional)",
  "话题不存在。": "Topic not found.",
  "共 {selectedTopic.shareCount} 条分享": "{selectedTopic.shareCount} shares ",
  "，符合筛选条件 {0} 条": ", {0} matching",
  "修改话题": "Edit topic",
  "删除话题": "Delete topic",
  "该话题下没有符合筛选条件的分享。": "No shares in this topic match the filters.",
  "该话题下暂无分享。": "No shares in this topic yet.",
  "查看分享": "View share",
  "分享不存在。": "Share not found.",
  "话题：": "Topic: ",
  "发布于 {formatDate(share.createdAt)}": "Published {formatDate(share.createdAt)}",
  "关联课程：": "Related course: ",
  "删除本分享": "Delete this share",
  "分享内容": "Share content",
  "发布": "Publish",
  "发布后即可上传 Word 文档、课件 PPT、图片、视频等文件。": "After publishing you can upload Word documents, slides, images, videos and other files.",
  "请选择左侧话题。": "Select a topic on the left.",
  "请先": "Please ",
  "后查看教师分享。": " to view teacher shares.",
  "选择话题": "Select a topic",
  "围绕管理员设定的话题，分享您在乡土课程实践中的观点与经验。": "Share your views and experience from teaching local-culture courses, on topics set by admins.",
  "话题筛选": "Topic filter",
  "全部话题": "All topics",
  "没有已发布分享的学校": "No schools with published shares",
  "找到 {filteredShares.length} 条分享": "{filteredShares.length} shares found ",
  "新建话题": " New topic",
  "暂无分享话题。": "No share topics yet.",
  "没有符合条件的分享。": "No matching shares.",
  "全部分享": " All shares",

  // template-admin
  "课程设计方案模板（WHY/WHAT/HOW）": "Course design template (WHY/WHAT/HOW)",
  "课时实施记录模板": "Lesson implementation record template",
  "加载相关课程计划失败。": "Failed to load related courses.",
  "加载模板版本失败。": "Failed to load template versions.",
  "模板已上传为新版本（未启用）。请查看字段，确认无误后手动设为启用。": "Template uploaded as a new version (not active). Check its fields, then activate it manually.",
  "模板上传失败。": "Template upload failed.",
  "确定将 v{version.version} 设为启用版本吗？此后新建的乡土课程设计将使用该版本的字段。":
    "Make v{version.version} the active version? New course designs will use its fields from now on.",
  "v{version.version} 已启用。": "v{version.version} is now active.",
  "启用失败。": "Activation failed.",
  "确定为 v{version.version} 发起迁移吗？使用该版本的 {version.dependentPlanCount} 个乡土课程设计将提示相关教师迁移到当前启用版本。":
    "Start migration for v{version.version}? The teachers of the {version.dependentPlanCount} course designs using it will be prompted to migrate to the active version.",
  "已发起迁移。": "Migration started.",
  "发起迁移失败。": "Failed to start migration.",
  "确定永久删除 v{version.version} 吗？此操作无法撤销。": "Permanently delete v{version.version}? This cannot be undone.",
  "v{version.version} 已删除。": "v{version.version} deleted.",
  "保存备注失败。": "Failed to save the note.",
  "上传新版本": "Upload new version",
  "暂无版本。": "No versions yet.",
  "版本": "Version",
  "来源文件": "Source file",
  "上传人": "Uploaded by",
  "创建时间": "Created",
  "字段": "Fields",
  "点击排序": "Click to sort",
  "启用中": "Active",
  "编辑备注": "Edit note",
  "添加备注": "Add note",
  "（初始模板）": "(initial template)",
  "查看字段": "View fields",
  "发起于 {0}": "Started {0}",
  "已发起迁移": "Migration started",
  "发起迁移": "Start migration",
  "设为启用": "Activate",
  "{0} · 每课时重复（如：{1}）": "{0} · repeated per lesson (e.g. {1})",
  "相关课程计划 · v{dependentModal.version.version}": "Related courses · v{dependentModal.version.version}",
  "暂无相关课程计划。": "No related courses.",

  // trash-button
  "回收站中有 {count} 个课程设计，{PLAN_TRASH_RETENTION_DAYS} 天内可恢复": "{count} course designs in the Trash, restorable within {PLAN_TRASH_RETENTION_DAYS} days",

  // Chinese punctuation used as standalone separators between JSX pieces
  "：": ": ",
  "（": " (",
  "）": ")",
  "（#": " (#",
  "《": "\"",
  "》": "\"",
  "》：": "\": ",
  "。": ".",
  "、": ", ",
  "；": "; ",

  // ---- Stored data values: stay Chinese in the DB/API, translated only where displayed ----
  // 乡土主题 (plan-options.js PLAN_THEMES)
  "自然地理风貌": "Natural geography & landscape",
  "生计方式实践": "Local livelihoods",
  "家乡物产探索": "Local products",
  "家乡美食文化": "Local food culture",
  "村落民居文化": "Village & vernacular architecture",
  "家族历史故事": "Family history",
  "传统节日民俗": "Traditional festivals & customs",
  "家乡人物故事": "Local figures",
  "童谣民歌俗语": "Nursery rhymes, folk songs & sayings",
  "民族服饰文化": "Ethnic dress",
  "家乡游戏娱乐": "Local games & pastimes",
  "传统手艺制作": "Traditional crafts",
  // 年级
  "一年级": "Grade 1",
  "二年级": "Grade 2",
  "三年级": "Grade 3",
  "四年级": "Grade 4",
  "五年级": "Grade 5",
  "六年级": "Grade 6",
  // 学期
  "秋季": "Fall",
  "春季": "Spring",
  // 文件类别 (artifacts.category)
  "实施记录文件": "Implementation record",
  "课件PPT": "Slides",
  "图片": "Image",
  "视频": "Video",
  "Word文档": "Word document",
  // AI 点评标准 default levels
  "优秀": "Excellent",
  "良好": "Good",
  "合格": "Satisfactory",
  "待改进": "Needs improvement",
};
export default en;
